import { React, useState, useEffect } from 'react';
import { Form, Button, Stack, Card } from 'react-bootstrap';
import * as api from 'services/api';
import './PhoneUpdater.css';
import { useTranslation } from 'react-i18next';

export function DwellingPhoneUpdater({ equipmentData, setEquipmentData, setShowDetails, interventionType }) {
  const { t } = useTranslation();
    const [newPhoneNumber, setNewPhoneNumber] = useState('');
    const [phoneToChange, setPhoneToChange] = useState('');
    const [showUpdatedPhones, setShowUpdatedPhones] = useState(false);
    const [phone1, setPhone1] = useState('');
    const [phone2, setPhone2] = useState('');
    const [phone3, setPhone3] = useState('');
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false);
    const [digitRegex, setDigitRegex] = useState(0);

    useEffect(() => {
        if (interventionType.selectedPhone === 1) setPhoneToChange(equipmentData.equipmentTelephone);
        else if (interventionType.selectedPhone === 2) setPhoneToChange(equipmentData.otherTelephone);
        else if (interventionType.selectedPhone === 3) setPhoneToChange(equipmentData.telephone3);

        setDigitRegex(new RegExp(`^\\d{0,${interventionType.controlDigitsNumber}}$`));

    }, [])

    const handleSave = async (event) => {

        event.preventDefault();

        const isDelete = interventionType.deletePhone === true;
        const selected = interventionType.selectedPhone;

        let phone1, phone2, phone3;

        if (isDelete) {
            // Solo actualiza el teléfono seleccionado
            phone1 = selected === 1 ? newPhoneNumber : equipmentData.equipmentTelephone;
            phone2 = selected === 2 ? newPhoneNumber : equipmentData.otherTelephone;
            phone3 = selected === 3 ? newPhoneNumber : equipmentData.telephone3;
        } else {
            // Mueve los teléfonos hacia adelante
            if (selected === 1) {
                phone1 = newPhoneNumber;
                phone2 = equipmentData.equipmentTelephone;
                phone3 = equipmentData.otherTelephone;
            } else if (selected === 2) {
                phone1 = equipmentData.equipmentTelephone;
                phone2 = newPhoneNumber;
                phone3 = equipmentData.otherTelephone;
            } else if (selected === 3) {
                phone1 = equipmentData.equipmentTelephone;
                phone2 = equipmentData.otherTelephone;
                phone3 = newPhoneNumber;
            }
        }

        setPhone1(phone1);
        setPhone2(phone2);
        setPhone3(phone3);

        const response = await api.updateEquipmentTelephone(equipmentData.equipmentIdent, phone1, phone2, phone3);
        setShowUpdatedPhones(true);
        if (response.status === 200) {
            setShowDetails(true);
        } else {
            console.error('Error al actualizar los teléfonos:');
        } 
        setShowDetails(true);
    }; 

    useEffect(() => {
        let hasPhoneDigits = false;
        hasPhoneDigits = newPhoneNumber.trim().length > 4;
        if (interventionType.controlDigitsNumber > 0) hasPhoneDigits = newPhoneNumber.trim().length === interventionType.controlDigitsNumber;

        setSaveButtonEnabled(hasPhoneDigits);
    }, [newPhoneNumber]);

    return (
        <Card className="UpdatePhone mt-3 p-4">
                <Card.Title className="mb-3">{t('pUpdaterUpdatePhone')}</Card.Title>

                <p>{t('pUpdaterDevicePhone') + interventionType.selectedPhone + ')'}: <b>{phoneToChange}</b></p>

                <Form>

                    <Stack direction="horizontal" className="justify-content-between" gap={3}>
                        <div className="flex-grow-1" style={{ maxWidth: '349px' }}>
                            <Form.Group>
                                <Form.Control
                                    className="bg-light UpdatePhone__input"
                                    type="number"
                                    placeholder={t('pUpdaterNewPhone')}
                                    value={newPhoneNumber}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (interventionType.controlDigitsNumber > 0) {
                                            if (digitRegex.test(value)) {
                                                setNewPhoneNumber(value);
                                            }
                                        } else {
                                            setNewPhoneNumber(value);
                                        }
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <Button type="submit"
                            variant={showUpdatedPhones ? 'outline-dark' : 'dark'}
                            onClick={handleSave}
                            disabled={!saveButtonEnabled}
                        >
                            {t('ccSave')}
                        </Button>
                    </Stack >
                    {showUpdatedPhones && (
                        <Stack direction="horizontal" gap={2} className="mt-3 flex-wrap flex-sm-nowrap">
                        <small className='flex-grow-1 w-100'>
                            <div className="d-inline d-sm-block">{t('pUpdaterPhone')} 1:</div> <b>{phone1}</b></small>
                        <small className='flex-grow-1 w-100'>
                            <div className="d-inline d-sm-block">{t('pUpdaterPhone')} 2:</div> <b>{phone2}</b></small>
                        <small className='flex-grow-1 w-100'>
                            <div className="d-inline d-sm-block">{t('pUpdaterPhone')} 3:</div> <b>{phone3}</b></small>
                        </Stack >
                    )}
            </Form>
        </Card>
    );
}
